import { useCityOptions as e } from "./useCityOptions.js";
import { useBusinessModalContext as i } from "../../BusinessModalContext.js";
const a = (t = !1) => {
  const {
    translations: o
  } = i(), s = e();
  return [{
    ...t && {
      label: o.cities
    },
    options: s
  }];
};
export {
  a as useCitySection
};
